import { Link } from 'react-router-dom';
import './CTABanner.css';

export default function CTABanner({
  title = "Let's Strengthen your Legal Operations",
  subtitle = 'Partner with Bridge Legal Services for reliable and professional paralegal support',
  ctaText = 'GET STARTED',
  ctaLink = '/contact-us',
}) {
  return (
    <section className="cta-banner">
      <div className="cta-banner__bg" />
      <div className="container cta-banner__content">
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
        <Link to={ctaLink} className="btn btn-primary">
          {ctaText}
        </Link>
      </div>
    </section>
  );
}
